<template>
  <v-app>
    <v-toolbar app flat style="max-width:100vw">
      <v-toolbar-title class="headline text-uppercase text-xs-center hidden-md-and-down">
        <span class="font-weight-light">#TommyGotHisGunn</span>
      </v-toolbar-title>
      <v-spacer class="hidden-md-and-down"></v-spacer>
      <v-btn
        flat
        outline
        @click="scrollToRSVP"
      > 
       RSVP
      </v-btn>
    </v-toolbar>

    <v-content>
      <HelloWorld ref="helloWorld" :scrollToRSVP=scrollToRSVP />
    </v-content>
  </v-app>
</template>

<script>
import HelloWorld from './components/HelloWorld'

export default {
  name: 'App',
  components: {
    HelloWorld
  },
  data () {
    return {
      //
    }
  },
  methods: {
    scrollToRSVP: function (){
      let helloWorldBoundingRect = this.$refs.helloWorld.$el.getBoundingClientRect()
      let rsvpBoundingRect = this.$refs.helloWorld.$refs.rsvp.getBoundingClientRect()
      let option2 = rsvpBoundingRect.y - helloWorldBoundingRect.y
      window.scrollTo(0, option2);
    }
  }
}
</script>
